import {
  collection,
  doc,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import { modelItemStream } from '../../firestore-mobx/stream'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import { buildUnsupportedConverter } from '../shared/noops'
import type { FirestoreSettingsSoundcheck } from './schema'
import { schema } from './schema'
import { SettingsSoundcheck } from '../../models/SettingsSoundcheck'

const unsupported = buildUnsupportedConverter<FirestoreSettingsSoundcheck>()

const converter: FirestoreDataConverter<FirestoreSettingsSoundcheck> = {
  toFirestore: unsupported.toFirestore,
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    return schema.parse(snapshot.data())
  },
}

export const getDocRef = (firestore: Firestore) => {
  return doc(collection(firestore, 'settings'), 'soundcheck').withConverter(
    converter
  )
}

export const getSettingsSoundcheck = (repository: FirebaseRepository) => {
  const docRef = getDocRef(repository.firestore)

  return modelItemStream(repository, docRef, SettingsSoundcheck)
}
